/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PaymentTansactionReponseDto { 
    amount?: number;
    status?: string | null;
    fromUserName?: string | null;
    fromUserEmail?: string | null;
    creditUnionName?: string | null;
    createdDate?: string;
    transactionType?: string | null;
    memberPhone?: string | null;
    transactionRefrenceId?: string | null;
    adjustedEntry?: boolean;
    hasReverted?: boolean;
}

